import React, { useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import CircularLoader from "../../../Component/CircularLoader";
import { addDays, formatDate } from "../../../Utis/GlobalFunctions";
import logo from "../../../assets/images/RMI-Logo.png";

const RMIDiplomaAdmission = () => {
    const [currentDate] = useState(new Date());
    const newDate = addDays(currentDate, 3);

    const [loading, setLoading] = useState(false);

    const [credentials] = useState({
        username: "RMI_Education",
        password: "Live@re25",
        clientId: "IhnChjFTk55eDsf",
        clientSecret: "H4QizHPLPeed3mL",
    });

    const [formData, setFormData] = useState({
        programme: "",
        name: "",
        fatherName: "",
        cnic: "",
        gender: "",
        phoneNumber: "",
        email: "",
        address: "",
        city: "",
        qualification: "",
        marks: "",
        passingYear: "",
        board: "",
        age: "",
        declaration: false,
    });

    const [errors, setErrors] = useState({});

    // =========================
    // PROGRAMME DATA
    // =========================

    const programmeData = [
        {
            id: 1,
            name: "Certified Nursing Assistant (CNA)",
            value: "CNA",
        },
        {
            id: 2,
            name: "Diploma in Anesthesia Technology",
            value: "AnesthesiaTechnology",
        },
        {
            id: 3,
            name: "Diploma in Dental Surgery Assistant (DSA)",
            value: "DSA",
        },
        {
            id: 4,
            name: "Diploma in Health Technology",
            value: "HealthTechnology",
        },
        {
            id: 5,
            name: "Diploma in Pathology Technology",
            value: "PathologyTechnology",
        },
        {
            id: 6,
            name: "Diploma in Physiotherapy",
            value: "Physiotherapy",
        },
        {
            id: 7,
            name: "Diploma in Radiology Technology",
            value: "RadiologyTechnology",
        },
    ];

    // =========================
    // GENDER DATA
    // =========================

    const genderData = [
        {
            id: 1,
            name: "Male",
            value: "Male",
        },
        {
            id: 2,
            name: "Female",
            value: "Female",
        },
    ];

    // =========================
    // QUALIFICATION DATA
    // =========================

    const qualificationData = [
        {
            id: 1,
            name: "Matric (Science)",
            value: "MatricScience",
        },
    ];

    // =========================
    // CITY DATA
    // =========================

    const cityData = [
        "Karachi",
        "Lahore",
        "Islamabad",
        "Rawalpindi",
        "Peshawar",
        "Quetta",
        "Multan",
        "Faisalabad",
        "Hyderabad",
        "Sukkur",
        "Abbottabad",
        "Mardan",
        "Other",
    ];

    // =========================
    // PASSING YEARS
    // =========================

    const passingYears = [];

    for (
        let year = new Date().getFullYear();
        year >= 1980;
        year--
    ) {
        passingYears.push(year);
    }

    // =========================
    // FIELD VALIDATION
    // =========================

    const validateField = (name, value) => {
        let fieldError = "";

        switch (name) {
            // =========================
            // REQUIRED FIELDS
            // =========================

            case "programme":
                if (!value) {
                    fieldError =
                        "Please select a programme.";
                }
                break;

            case "name":
                if (!String(value).trim()) {
                    fieldError =
                        "Please enter your full name.";
                }
                break;

            case "phoneNumber":
                if (!String(value).trim()) {
                    fieldError =
                        "Please enter mobile / phone number.";
                }
                break;

            case "email":
                if (!String(value).trim()) {
                    fieldError =
                        "Please enter your email address.";
                } else if (
                    !/\S+@\S+\.\S+/.test(value)
                ) {
                    fieldError =
                        "Please enter a valid email address.";
                }
                break;

            case "city":
                if (!value) {
                    fieldError =
                        "Please select your city.";
                }
                break;

            case "qualification":
                if (!value) {
                    fieldError =
                        "Please select your academic qualification.";
                } else if (
                    value !== "MatricScience"
                ) {
                    fieldError =
                        "Only Matric (Science) is required.";
                }
                break;

            case "marks":
                if (!String(value).trim()) {
                    fieldError =
                        "Please enter your Matric / Equivalent marks.";
                } else if (Number(value) < 50) {
                    fieldError =
                        "Minimum 50% marks are required.";
                } else if (Number(value) > 100) {
                    fieldError =
                        "Marks cannot be greater than 100.";
                }
                break;

            case "declaration":
                if (!value) {
                    fieldError =
                        "Please confirm the applicant declaration.";
                }
                break;

            // =========================
            // OPTIONAL FIELDS
            // =========================

            case "fatherName":
            case "cnic":
            case "gender":
            case "address":
            case "passingYear":
            case "board":
            case "age":
                break;

            default:
                break;
        }

        return fieldError;
    };

    // =========================
    // HANDLE CHANGE
    // =========================

    const handleChange = (e) => {
        const {
            name,
            value,
            type,
            checked,
        } = e.target;

        const updatedValue =
            type === "checkbox"
                ? checked
                : value;

        const updatedFormData = {
            ...formData,
            [name]: updatedValue,
        };

        setFormData(updatedFormData);

        const fieldError = validateField(
            name,
            updatedValue
        );

        setErrors((prev) => ({
            ...prev,
            [name]: fieldError,
        }));
    };

    // =========================
    // FORM VALIDATION
    // =========================

    const validateForm = () => {
        const newErrors = {};

        const requiredFields = [
            "programme",
            "name",
            "phoneNumber",
            "email",
            "city",
            "qualification",
            "marks",
            "declaration",
        ];

        requiredFields.forEach((field) => {
            const fieldError = validateField(
                field,
                formData[field]
            );

            if (fieldError) {
                newErrors[field] = fieldError;
            }
        });

        setErrors(newErrors);

        // =========================
        // SCROLL TO FIRST ERROR
        // =========================

        if (
            Object.keys(newErrors).length > 0
        ) {
            const firstErrorField =
                Object.keys(newErrors)[0];

            setTimeout(() => {
                const element =
                    document.querySelector(
                        `[name="${firstErrorField}"]`
                    );

                if (element) {
                    element.scrollIntoView({
                        behavior: "smooth",
                        block: "center",
                    });

                    element.focus();
                }
            }, 100);

            return false;
        }

        return true;
    };

    // =========================
    // GET AUTH TOKEN
    // =========================

    const getAuthToken = async (
        clientId,
        clientSecret
    ) => {
        const tokenResponse = await axios.post(
            `${process.env.REACT_APP_PAYPRO_LIVEAPI}/auth`,
            {
                clientid: clientId,
                clientsecret: clientSecret,
            }
        );

        return tokenResponse.data.token;
    };

    // =========================
    // CREATE PAYPRO ORDER
    // =========================

    const payproCreateOrder = async (e) => {
        e.preventDefault();

        const isValid = validateForm();

        if (!isValid) {
            return;
        }

        try {
            setLoading(true);

            // =========================
            // GET TOKEN
            // =========================

            const token = await getAuthToken(
                credentials.clientId,
                credentials.clientSecret
            );

            const headers = {
                token: token,
                "Content-Type": "application/json",
            };

            // =========================
            // PAYPRO PAYLOAD
            // =========================

            const payload = [
                {
                    MerchantId:
                        credentials.username,
                },
                {
                    OrderNumber: `${+currentDate}`,

                    OrderAmount: "500",

                    OrderDueDate:
                        formatDate(newDate),

                    OrderType: "Service",

                    IssueDate:
                        formatDate(currentDate),

                    OrderExpireAfterSeconds:
                        "0",

                    CustomerName:
                        formData.name,

                    CustomerMobile:
                        formData.phoneNumber,

                    CustomerEmail:
                        formData.email,

                    CustomerAddress:
                        formData.address,

                    BillDetail01: [
                        {
                            programme:
                                formData.programme,

                            programmeName:
                                programmeData.find(
                                    (item) =>
                                        item.value ===
                                        formData.programme
                                )?.name || "",

                            // OPTIONAL
                            fatherName:
                                formData.fatherName,

                            // OPTIONAL
                            cnic:
                                formData.cnic,

                            // OPTIONAL
                            gender:
                                formData.gender,

                            // REQUIRED
                            city:
                                formData.city,

                            // REQUIRED
                            qualification:
                                formData.qualification,

                            // REQUIRED
                            marks:
                                formData.marks,

                            // OPTIONAL
                            passingYear:
                                formData.passingYear,

                            // OPTIONAL
                            board:
                                formData.board,

                            // OPTIONAL
                            age:
                                formData.age,

                            applicationFee:
                                "500",

                            feeType:
                                "Application Fee",

                            declaration:
                                formData.declaration
                                    ? "Confirmed"
                                    : "Not Confirmed",
                        },
                    ],
                },
            ];

            console.log(
                "PayPro Create Order Payload:",
                payload
            );

            // =========================
            // CREATE ORDER API
            // =========================

            const url =
                `${process.env.REACT_APP_PAYPRO_LIVEAPI}/create-order`;

            const response = await axios.post(
                url,
                payload,
                {
                    headers,
                }
            );

            console.log(
                "PayPro Create Order Response:",
                response.data
            );

            // =========================
            // PAYPRO ERROR
            // =========================

            if (
                response.data?.data?.[0]?.Status ===
                "03"
            ) {
                await Swal.fire({
                    icon: "error",
                    title:
                        response?.data?.data?.[1]
                            ?.Description ||
                        "Unable to create application.",
                    showConfirmButton: true,
                });

                setLoading(false);
                return;
            }

            // =========================
            // PAYMENT URL
            // =========================

            const marketplaceUrl =
                response.data?.data?.[1]
                    ?.Click2Pay;

            if (!marketplaceUrl) {
                await Swal.fire({
                    icon: "error",
                    title:
                        "Payment URL was not generated.",
                    showConfirmButton: true,
                });

                setLoading(false);
                return;
            }

            // =========================
            // SUCCESS MESSAGE
            // =========================

            await Swal.fire({
                icon: "success",
                title:
                    "Redirecting to Payment",
                showConfirmButton: false,
                timer: 1500,
            });

            setLoading(false);

            // =========================
            // REDIRECT
            // =========================

            window.top.location.href =
                marketplaceUrl
        } catch (error) {
            console.error(
                "Error creating order:",
                error
            );

            setLoading(false);

            await Swal.fire({
                icon: "error",
                title:
                    "Something went wrong.",
                text:
                    "Unable to process your application. Please try again.",
                showConfirmButton: true,
            });
        }
    };

    // =========================
    // INPUT CLASS
    // =========================

    const getInputClass = (fieldName) => {
        return `input-field w-full box-border px-3 py-3 bg-gray-50 border text-gray-900 text-sm rounded-lg focus:ring-cyan-600 focus:border-cyan-600 block ${
            errors[fieldName]
                ? "border-red-500"
                : "border-gray-300"
        }`;
    };

    return (
        <div className="w-11/12 lg:w-2/4 md:w-4/5 bg-white border rounded-lg shadow relative m-auto my-8">

            {/* =========================
                HEADER / LOGO
            ========================= */}

            <div className="text-center px-6 pt-8 pb-2">

                <img
                    src={logo}
                    alt="Rehman Medical Institute"
                    className="mx-auto w-full max-w-[300px] h-auto object-contain"
                />

                <h1 className="text-2xl md:text-3xl font-bold text-gray-900 mt-6">
                    Registration Form – Diploma Programme
                </h1>

                <p className="text-sm md:text-base text-gray-500 mt-2">
                    Online Admission Registration
                </p>

            </div>

            {/* =========================
                FORM
            ========================= */}

            <form
                className="p-6 space-y-8"
                onSubmit={payproCreateOrder}
            >

                {/* =========================
                    1. PROGRAMME
                ========================= */}

                <div>
                    <h2 className="text-xl font-semibold text-gray-900 mb-4">
                        1. Select Your Programme
                    </h2>

                    <label className="text-md font-medium text-gray-900 block mb-2">
                        Select Programme{" "}
                        <span className="text-red-600">
                            *
                        </span>
                    </label>

                    <select
                        name="programme"
                        value={
                            formData.programme
                        }
                        onChange={
                            handleChange
                        }
                        className={getInputClass(
                            "programme"
                        )}
                    >
                        <option value="">
                            Select Programme
                        </option>

                        {programmeData.map(
                            (programme) => (
                                <option
                                    key={
                                        programme.id
                                    }
                                    value={
                                        programme.value
                                    }
                                >
                                    {
                                        programme.name
                                    }
                                </option>
                            )
                        )}
                    </select>

                    {errors.programme && (
                        <p className="text-red-600 text-sm mt-1">
                            {
                                errors.programme
                            }
                        </p>
                    )}

                    <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-3 mt-3 text-sm text-gray-700">
                        <strong>
                            Note:
                        </strong>{" "}
                        CNA is offered by Rehman
                        College of Nursing (RCN)
                        and differs from other
                        diploma programmes in
                        terms of its regulatory
                        framework.
                    </div>
                </div>

                {/* =========================
                    2. APPLICANT INFORMATION
                ========================= */}

                <div>
                    <h2 className="text-xl font-semibold text-gray-900 mb-4">
                        2. Applicant Information
                    </h2>

                    <div className="flex flex-wrap gap-6">

                        {/* FULL NAME */}

                        <div className="w-full sm:w-[calc(50%-0.75rem)] min-w-0 flex-shrink-0">

                            <label className="form-label">
                                Full Name{" "}
                                <span className="text-red-600">
                                    *
                                </span>
                            </label>

                            <input
                                type="text"
                                name="name"
                                value={
                                    formData.name
                                }
                                onChange={
                                    handleChange
                                }
                                className={getInputClass(
                                    "name"
                                )}
                                placeholder="Enter your full name"
                            />

                            {errors.name && (
                                <p className="error-text text-red-600 text-sm mt-1">
                                    {
                                        errors.name
                                    }
                                </p>
                            )}

                        </div>

                        {/* FATHER NAME OPTIONAL */}

                        <div className="w-full sm:w-[calc(50%-0.75rem)] min-w-0 flex-shrink-0">

                            <label className="form-label">
                                Father's Name
                            </label>

                            <input
                                type="text"
                                name="fatherName"
                                value={
                                    formData.fatherName
                                }
                                onChange={
                                    handleChange
                                }
                                className={getInputClass(
                                    "fatherName"
                                )}
                                placeholder="Enter father's full name"
                            />

                        </div>

                        {/* CNIC OPTIONAL */}

                        <div className="w-full sm:w-[calc(50%-0.75rem)] min-w-0 flex-shrink-0">

                            <label className="form-label">
                                CNIC / B-Form Number
                            </label>

                            <input
                                type="text"
                                name="cnic"
                                value={
                                    formData.cnic
                                }
                                onChange={
                                    handleChange
                                }
                                className={getInputClass(
                                    "cnic"
                                )}
                                placeholder="Enter CNIC or B-Form number"
                            />

                        </div>

                        {/* GENDER OPTIONAL */}

                        <div className="w-full sm:w-[calc(50%-0.75rem)] min-w-0 flex-shrink-0">

                            <label className="form-label">
                                Gender
                            </label>

                            <select
                                name="gender"
                                value={
                                    formData.gender
                                }
                                onChange={
                                    handleChange
                                }
                                className={getInputClass(
                                    "gender"
                                )}
                            >
                                <option value="">
                                    Select Gender
                                </option>

                                {genderData.map(
                                    (gender) => (
                                        <option
                                            key={
                                                gender.id
                                            }
                                            value={
                                                gender.value
                                            }
                                        >
                                            {
                                                gender.name
                                            }
                                        </option>
                                    )
                                )}

                            </select>

                        </div>

                        {/* AGE OPTIONAL */}

                        <div className="w-full sm:w-[calc(50%-0.75rem)] min-w-0 flex-shrink-0">

                            <label className="form-label">
                                Age
                            </label>

                            <input
                                type="number"
                                name="age"
                                value={
                                    formData.age
                                }
                                onChange={
                                    handleChange
                                }
                                className={getInputClass(
                                    "age"
                                )}
                                placeholder="Enter age"
                                min="1"
                                max="100"
                            />

                            <p className="text-xs text-gray-500 mt-1">
                                {formData.programme ===
                                "CNA"
                                    ? "CNA age limit: 17–35 years"
                                    : "Age limit: up to 30 years"}
                            </p>

                        </div>

                    </div>
                </div>

                {/* =========================
                    3. CONTACT INFORMATION
                ========================= */}

                <div>

                    <h2 className="text-xl font-semibold text-gray-900 mb-4">
                        3. Contact Information
                    </h2>

                    <div className="flex flex-wrap gap-6">

                        {/* PHONE REQUIRED */}

                        <div className="w-full sm:w-[calc(50%-0.75rem)] min-w-0 flex-shrink-0">

                            <label className="form-label">
                                Mobile / Phone Number{" "}
                                <span className="text-red-600">
                                    *
                                </span>
                            </label>

                            <input
                                type="tel"
                                name="phoneNumber"
                                value={
                                    formData.phoneNumber
                                }
                                onChange={
                                    handleChange
                                }
                                className={getInputClass(
                                    "phoneNumber"
                                )}
                                placeholder="Enter mobile number"
                            />

                            {errors.phoneNumber && (
                                <p className="error-text text-red-600 text-sm mt-1">
                                    {
                                        errors.phoneNumber
                                    }
                                </p>
                            )}

                        </div>

                        {/* EMAIL REQUIRED */}

                        <div className="w-full sm:w-[calc(50%-0.75rem)] min-w-0 flex-shrink-0">

                            <label className="form-label">
                                Email Address{" "}
                                <span className="text-red-600">
                                    *
                                </span>
                            </label>

                            <input
                                type="email"
                                name="email"
                                value={
                                    formData.email
                                }
                                onChange={
                                    handleChange
                                }
                                className={getInputClass(
                                    "email"
                                )}
                                placeholder="Enter email address"
                            />

                            {errors.email && (
                                <p className="error-text text-red-600 text-sm mt-1">
                                    {
                                        errors.email
                                    }
                                </p>
                            )}

                        </div>

                        {/* ADDRESS OPTIONAL */}

                        <div className="w-full">

                            <label className="form-label">
                                Address
                            </label>

                            <textarea
                                name="address"
                                rows={3}
                                value={
                                    formData.address
                                }
                                onChange={
                                    handleChange
                                }
                                className={getInputClass(
                                    "address"
                                )}
                                placeholder="Enter complete address"
                                style={{
                                    resize: "none",
                                }}
                            />

                        </div>

                        {/* CITY REQUIRED */}

                        <div className="w-full sm:w-[calc(50%-0.75rem)] min-w-0 flex-shrink-0">

                            <label className="form-label">
                                City{" "}
                                <span className="text-red-600">
                                    *
                                </span>
                            </label>

                            <select
                                name="city"
                                value={
                                    formData.city
                                }
                                onChange={
                                    handleChange
                                }
                                className={getInputClass(
                                    "city"
                                )}
                            >
                                <option value="">
                                    Select city
                                </option>

                                {cityData.map(
                                    (city) => (
                                        <option
                                            key={
                                                city
                                            }
                                            value={
                                                city
                                            }
                                        >
                                            {city}
                                        </option>
                                    )
                                )}

                            </select>

                            {errors.city && (
                                <p className="error-text text-red-600 text-sm mt-1">
                                    {
                                        errors.city
                                    }
                                </p>
                            )}

                        </div>

                    </div>
                </div>

                {/* =========================
                    4. ACADEMIC INFORMATION
                ========================= */}

                <div>

                    <h2 className="text-xl font-semibold text-gray-900 mb-4">
                        4. Academic Information
                    </h2>

                    <div className="flex flex-wrap gap-6">

                        {/* QUALIFICATION REQUIRED */}

                        <div className="w-full sm:w-[calc(50%-0.75rem)] min-w-0 flex-shrink-0">

                            <label className="form-label">
                                Qualification{" "}
                                <span className="text-red-600">
                                    *
                                </span>
                            </label>

                            <select
                                name="qualification"
                                value={
                                    formData.qualification
                                }
                                onChange={
                                    handleChange
                                }
                                className={getInputClass(
                                    "qualification"
                                )}
                            >
                                <option value="">
                                    Select Qualification
                                </option>

                                {qualificationData.map(
                                    (item) => (
                                        <option
                                            key={
                                                item.id
                                            }
                                            value={
                                                item.value
                                            }
                                        >
                                            {
                                                item.name
                                            }
                                        </option>
                                    )
                                )}

                            </select>

                            {errors.qualification && (
                                <p className="error-text text-red-600 text-sm mt-1">
                                    {
                                        errors.qualification
                                    }
                                </p>
                            )}

                        </div>

                        {/* MARKS REQUIRED */}

                        <div className="w-full sm:w-[calc(50%-0.75rem)] min-w-0 flex-shrink-0">

                            <label className="form-label">
                                Matric (Science) Marks (%){" "}
                                <span className="text-red-600">
                                    *
                                </span>
                            </label>

                            <input
                                type="number"
                                name="marks"
                                value={
                                    formData.marks
                                }
                                onChange={
                                    handleChange
                                }
                                className={getInputClass(
                                    "marks"
                                )}
                                placeholder="Enter Marks"
                                min="0"
                                max="100"
                            />

                            {errors.marks && (
                                <p className="error-text text-red-600 text-sm mt-1">
                                    {
                                        errors.marks
                                    }
                                </p>
                            )}

                        </div>

                        {/* PASSING YEAR OPTIONAL */}

                        <div className="w-full sm:w-[calc(50%-0.75rem)] min-w-0 flex-shrink-0">

                            <label className="form-label">
                                Year of Passing
                            </label>

                            <select
                                name="passingYear"
                                value={
                                    formData.passingYear
                                }
                                onChange={
                                    handleChange
                                }
                                className={getInputClass(
                                    "passingYear"
                                )}
                            >
                                <option value="">
                                    Select year
                                </option>

                                {passingYears.map(
                                    (year) => (
                                        <option
                                            key={
                                                year
                                            }
                                            value={
                                                year
                                            }
                                        >
                                            {year}
                                        </option>
                                    )
                                )}

                            </select>

                        </div>

                        {/* BOARD OPTIONAL */}

                        <div className="w-full sm:w-[calc(50%-0.75rem)] min-w-0 flex-shrink-0">

                            <label className="form-label">
                                Board / Institution
                            </label>

                            <input
                                type="text"
                                name="board"
                                value={
                                    formData.board
                                }
                                onChange={
                                    handleChange
                                }
                                className={getInputClass(
                                    "board"
                                )}
                                placeholder="Enter board/institution name"
                            />

                        </div>

                    </div>
                </div>

                {/* =========================
                    ELIGIBILITY
                ========================= */}

                <div className="bg-gray-50 border rounded-lg p-5">

                    <h2 className="text-xl font-semibold text-gray-900 mb-3">
                        Eligibility Criteria
                    </h2>

                    <ul className="list-disc pl-5 space-y-1 text-sm text-gray-700">

                        <li>
                            Matric (Science) with
                            minimum 50% marks
                        </li>

                        <li>
                            Age: Up to 30 years
                        </li>

                        <li>
                            For CNA, the age limit
                            is 17–35 years.
                        </li>

                        <li>
                            Male and female candidates
                            are eligible to apply.
                        </li>

                    </ul>

                </div>



                {/* =========================
                    DECLARATION REQUIRED
                ========================= */}

                <div>

                    <label className="flex items-start gap-3 cursor-pointer">

                        <input
                            type="checkbox"
                            name="declaration"
                            checked={
                                formData.declaration
                            }
                            onChange={
                                handleChange
                            }
                            className={`mt-1 w-4 h-4 ${
                                errors.declaration
                                    ? "border-red-500"
                                    : ""
                            }`}
                        />

                        <span className="text-sm text-gray-700">

                            <strong>
                                Applicant Declaration:
                            </strong>{" "}
                            I confirm that I meet
                            the eligibility criteria
                            and that the information
                            provided in this form is
                            complete and accurate.

                            <span className="text-red-600">
                                {" "}*
                            </span>

                        </span>

                    </label>

                    {errors.declaration && (
                        <p className="error-text text-red-600 text-sm mt-1">
                            {
                                errors.declaration
                            }
                        </p>
                    )}

                </div>

                {/* =========================
                    APPLICATION FEE
                ========================= */}

                <div className="border rounded-lg p-5 flex items-center justify-between bg-gray-50">

                    <div>

                        <p className="text-sm text-gray-600">
                            Application Fee
                        </p>

                        <p className="text-2xl font-bold text-gray-900">
                            PKR 500
                        </p>

                    </div>

                    <div className="text-sm text-gray-500">
                        Payable online
                    </div>

                </div>

                {/* =========================
                    SUBMIT
                ========================= */}

                <div className="flex items-center justify-center">

                    <button
                        type="submit"
                        disabled={loading}
                        className="flex items-center justify-center gap-2 py-3 px-8 text-white bg-cyan-600 hover:bg-cyan-700 disabled:opacity-60 focus:ring-4 focus:ring-cyan-200 font-medium rounded-lg text-sm"
                    >
                        {loading ? (
                            <>
                                Processing...
                                <CircularLoader />
                            </>
                        ) : (
                            "Submit Application & Pay PKR 500"
                        )}
                    </button>

                </div>

            </form>
        </div>
    );
};

export default RMIDiplomaAdmission;